/*!

=========================================================
* Argon Dashboard React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Users from "./views/users/Index.jsx";
import Articles from "./views/articles/Index.jsx";
import Bbs from "./views/bbs/Index.jsx";
import BusAdvs from "./views/busadvs/Index.jsx";
import CatAdvs from "./views/catadvs/Index.jsx";
import Logs from "./views/logs/Index.jsx";
import OtherArticles from "./views/otherarticles/Index.jsx";
import Subs from "./views/subs/Index.jsx";
import YellowPages from "./views/yellowpages/Index.jsx";
import Videos from "./views/videos/Index.jsx";
import Login from "./views/auth/Login.jsx";
import Register from "./views/auth/Register.jsx";
// import Nav from "./views/profile/Nav.jsx";
import Profile from "./views/profile/Edit.jsx";
import ForgotPassword from "./views/auth/ForgotPassword.jsx";
import ResetPassword from "./views/auth/ResetPassword.jsx";

import IconUser from "./components/Icon/User.jsx";
import IconUserGroup from "./components/Icon/UserGroup.jsx";
import IconNewspaper from "./components/Icon/Newspaper.jsx";
import IconTV from "./components/Icon/TV.jsx";
import IconYellowPage from "./components/Icon/YellowPage.jsx";
import IconListBullet from "./components/Icon/ListBullet.jsx";
import IconChat from "./components/Icon/Chat.jsx";
import IconMegaphone from "./components/Icon/Megaphone.jsx";
import IconInboxArrowDown from "./components/Icon/InboxArrowDown.jsx";
import IconEnvelope from "./components/Icon/Envelope.jsx";
import IconCog from "./components/Icon/Cog.jsx";
import IconLogout from "./components/Icon/Logout.jsx";
import IconKey from "./components/Icon/Key.jsx";
// import Index from "./views/examples/Index.jsx";
// import Profile from "./views/examples/Profile.jsx";

var routes = [
  {
    path: "/profile",
    name: "個人資料",
    icon: IconUser,
    component: Profile,
    layout: "/dash/admin",
    roles: [100, 200, 300, 400, 500],
  },
  {
    path: "/users",
    name: "用戶管理",
    icon: IconUserGroup,
    component: Users,
    layout: "/dash/admin",
    roles: [100, 200],
  },
  {
    path: "/articles",
    name: "文章管理",
    icon: IconNewspaper,
    component: Articles,
    layout: "/dash/admin",
    roles: [100, 200, 300, 400],
  },
  {
    path: "/videos",
    name: "電視視頻",
    icon: IconTV,
    component: Videos,
    layout: "/dash/admin",
    roles: [100, 200, 300, 400],
  },
  {
    path: "/yellow-pages",
    name: "黃頁管理",
    icon: IconYellowPage,
    component: YellowPages,
    layout: "/dash/admin",
    roles: [100, 200],
  },
  {
    path: "/category-advertisements",
    name: "分類廣告",
    icon: IconListBullet,
    component: CatAdvs,
    layout: "/dash/admin",
    roles: [100, 200],
  },
  {
    path: "/bbs",
    name: "美南論壇",
    icon: IconChat,
    component: Bbs,
    layout: "/dash/admin",
    roles: [100, 200, 300, 400, 500],
  },
  {
    path: "/business-advertisements",
    name: "商業廣告",
    icon: IconMegaphone,
    component: BusAdvs,
    layout: "/dash/admin",
    roles: [100, 200],
  },
  {
    path: "/other-articles",
    name: "投稿管理",
    icon: IconInboxArrowDown,
    component: OtherArticles,
    layout: "/dash/admin",
    roles: [100, 200, 300],
  },
  {
    path: "/subscriptions",
    name: "訂閱管理",
    icon: IconEnvelope,
    component: Subs,
    layout: "/dash/admin",
    roles: [100, 200, 500],
  },
  {
    path: "/logs",
    name: "操作記錄",
    icon: IconCog,
    component: Logs,
    layout: "/dash/admin",
    roles: [100],
  },
  {
    path: "/login",
    name: "Login",
    icon: "ni ni-key-25 text-info",
    component: Login,
    layout: "/dash/auth",
    roles: [100, 200, 300, 400, 500],
  },
  {
    path: "/forgot-password",
    name: "ForgotPassword",
    icon: "ni ni-key-25 text-info",
    component: ForgotPassword,
    layout: "/dash/auth",
    roles: [100, 200, 300, 400, 500],
  },
  {
    path: "/reset-password/:token",
    name: "ResetPassword",
    icon: IconKey,
    component: ResetPassword,
    layout: "/dash/auth",
    roles: [100, 200, 300, 400, 500],
  },
  {
    path: "/register",
    name: "Register",
    icon: IconLogout,
    component: Register,
    layout: "/dash/auth",
    roles: [100, 200, 300, 400, 500],
  },
];
export default routes;
